import { useMemo } from 'react';
import { EMPTY_WATERMARK_SUMMARY, type WatermarkSummary } from 'fym-shared/src/music24/watermarkUpsell';
import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useUserToken } from '../../../redux/slices/appInfo/hooks';

export interface WatermarkSummaryState {
  /** The answer of the server; the empty summary before it comes and for a signed-out visitor. */
  summary: WatermarkSummary;
  /** True when `summary` is an answer of the server. */
  isLoaded: boolean;
}

/**
 * The watermarked files of the active workspace (`billing.watermarkSummary`, trial upsell spec
 * 2026-10-13 §5.1). Every count on every upsell surface reads this one query.
 * `useWatermarkSummaryRealtime` (mounted one time, in `WatermarkUpsellHost`) reads it again on
 * `kit.asset.updated` and `reel.updated`.
 */
export function useWatermarkSummary(): WatermarkSummaryState {
  const trpcAPI = useTRPCAPI();
  const token = useUserToken();
  const { data } = useTRPCQuery(
    trpcAPI.billing.watermarkSummary.queryOptions(undefined, {
      enabled: token !== null && token !== '',
      staleTime: 30_000,
    })
  );
  return useMemo(() => {
    const summary: WatermarkSummary = data ?? EMPTY_WATERMARK_SUMMARY;
    return { summary, isLoaded: data !== undefined };
  }, [data]);
}
